var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconContainer, { IconSVG } from "./IconContainer";
var IconCarousel = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M12.9,19.3l4.3-4.3-4.3-4.3" }),
            React.createElement("path", { d: "M22.6,6.5v17.3c0,1.2-1,2.2-2.2,2.2h-10.8c-1.2,0-2.2-1-2.2-2.2V6.5c0-1.2,1-2.2,2.2-2.2h10.8c1.2,0,2.2,1,2.2,2.2Z" }),
            React.createElement("path", { d: "M3.7,23.1h0c-1.2,0-2.2-1-2.2-2.2v-11.4c0-1.2,1-2.2,2.2-2.2h0" }),
            React.createElement("path", { d: "M26.3,23.1h0c1.2,0,2.2-1,2.2-2.2v-11.4c0-1.2-1-2.2-2.2-2.2h0" }))));
});
export default IconCarousel;
//# sourceMappingURL=IconCarousel.js.map